import format from 'date-fns/format';
import { es } from 'date-fns/locale';

// Los builders de CRM mandan cada bucket como mediodía UTC: reconstruir la fecha con
// componentes UTC evita que en zonas negativas caiga en el día anterior.
export const bucketDate = timestamp => {
  const date = new Date(timestamp * 1000);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

// Etiqueta según la granularidad que eligió el backend para el rango pedido
// (`range.granularity`: day | week | month).
export const bucketLabel = (timestamp, granularity = 'day') => {
  const date = bucketDate(timestamp);
  switch (granularity) {
    case 'month':
      return format(date, 'MMM yyyy', { locale: es });
    case 'week':
      // Mismo formato corto que usa el gráfico del embudo para semanas.
      return `Sem ${format(date, 'dd/MM')}`;
    default:
      return format(date, 'dd/MM');
  }
};
